/*
 * Naturif – Comandă în bulk (matrice culori × mărimi)
 * ---------------------------------------------------
 *  - Personalizarea vine din blocul naturif-personalizare (înlocuiește Options Price Calculator):
 *    prețul personalizării = prețul variantei produsului-serviciu pentru pragul de cantitate.
 *    În coș intră, în aceeași cerere, textilul (pe culori/mărimi) + liniile de serviciu + setup-ul,
 *    toate legate prin _nf_group. Fără draft orders, fără cart transform, fără Shopify Plus.
 *  - Pragurile de reducere vin din tabelul naturif-reduceri (sau, ca rezervă, din widget-ul DealEasy);
 *    discountul efectiv se aplică în coș de regula de discount.
 *  - naturif-cart-sync.js ține coșul corect când clientul schimbă cantitățile în coș.
 */
(function () {
  'use strict';
  if (window.NaturifBulkOrder) return;

  var ROOT_SELECTOR = '[data-naturif-bulk-order]';

  var TEXT = {
    title: 'Alege culorile, mărimile și cantitățile',
    subtitle: 'Introdu câte bucăți vrei din fiecare combinație. Personalizarea aleasă mai sus se aplică tuturor pieselor.',
    subtitleNoCalc: 'Introdu câte bucăți vrei din fiecare combinație.',
    colorHint: 'Apasă pe o culoare ca să vezi produsul în acea culoare.',
    tabsHint: 'Alege culoarea, apoi completează cantitățile pe mărimi. Poți adăuga mai multe culori înainte de „Adaugă în coș”.',
    colorLabel: 'Culoare',
    showColor: 'Vezi produsul în culoarea {color}',
    unitPrice: 'Preț unitar',
    addAll: 'Adaugă în coș',
    adding: 'Se adaugă…',
    total: 'Total',
    pieces: 'buc.',
    subtotal: 'Subtotal estimat',
    subtotalNote: 'Discountul pe cantitate se aplică automat în coș.',
    perPiece: '/buc.',
    noQty: 'Introdu cel puțin o cantitate.',
    personalization: 'Personalizare',
    setup: 'Setup (o singură dată)',
    genericError: 'A apărut o eroare la adăugarea în coș. Te rugăm să încerci din nou.',
    success: '{qty} {pieces} adăugate în coș.',
    unavailable: 'Epuizat',
    notOffered: 'Combinație indisponibilă',
    stock: 'stoc',
    maxStock: 'Stoc disponibil pentru {variant}: {max} {pieces}.',
    tierReached: 'Total {total} {pieces} din acest produs → se aplică {pct}% reducere în coș.',
    tierNext: 'Mai adaugă {left} {pieces} pentru {pct}% reducere.',
    vat: '+ TVA'
  };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function cssEscape(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(String(s)) : String(s).replace(/["\\\]]/g, '\\$&');
  }
  function fmt(tpl, vars) {
    return String(tpl).replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
  }
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') node.className = attrs[k];
      else if (k === 'text') node.textContent = attrs[k];
      else if (k === 'html') node.innerHTML = attrs[k];
      else if (k.indexOf('on') === 0 && typeof attrs[k] === 'function') node.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null && attrs[k] !== false) node.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return node;
  }

  /* ---------- bani ---------- */
  // Prețurile Shopify sunt în bani (RON cu TVA). Afișăm net + TVA, ca restul site-ului.
  function formatMoney(grossMinor, cfg) {
    var net = grossMinor / (cfg.vatRate || 1);
    var fixed = (Math.round(net) / 100).toFixed(2);
    var parts = fixed.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var out = intPart + ',' + parts[1] + ' ' + (cfg.currencySuffix || 'lei');
    if ((cfg.vatRate || 1) !== 1) out += ' ' + TEXT.vat;
    return out;
  }

  /* ---------- Personalizare Naturif (naturif-personalizare.js) ---------- */
  function personalizare(productId) {
    return window.NaturifPersonalizare ? window.NaturifPersonalizare.forProduct(productId) : null;
  }

  // Bucățile de textil deja în coș pentru același grup de personalizare (se adună la prag).
  function groupQtyInCart(cart, groupId) {
    if (!cart || !groupId) return 0;
    return (cart.items || []).reduce(function (sum, item) {
      var p = item.properties || {};
      return p._nf_group === groupId && p._nf_role === 't' ? sum + item.quantity : sum;
    }, 0);
  }

  // Alte proprietăți puse în formularul de produs de temă/alte aplicații (fără resturile vechiului calculator).
  function readFormProperties(form) {
    var props = {};
    if (!form) return props;
    $$('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]', form).forEach(function (input) {
      if (input.disabled || input.type === 'file') return;
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      var m = input.name.match(/^properties\[(.+)\]$/);
      if (m && m[1].indexOf('__oo') !== 0 && m[1] !== '_data' && m[1] !== '_admin_summary') props[m[1]] = input.value;
    });
    return props;
  }

  /* ---------- praguri de reducere (naturif-reduceri.js; rezervă: widget-ul Dealeasy) ---------- */
  function readDealeasyTiers() {
    var tiers = [];
    $$('lb-volume-discount tr, #lb-volume-discount tr').forEach(function (tr) {
      var tds = tr.querySelectorAll('td');
      if (tds.length < 2) return;
      var q = tds[0].textContent.match(/(\d+)/);
      var p = tds[1].textContent.match(/(\d+(?:[.,]\d+)?)\s*%/);
      if (q && p) tiers.push({ min: parseInt(q[1], 10), pct: parseFloat(p[1].replace(',', '.')) });
    });
    tiers.sort(function (a, b) { return a.min - b.min; });
    return tiers;
  }
  function discountTiers(productId) {
    return window.NaturifReduceri ? window.NaturifReduceri.tiers(productId) : readDealeasyTiers();
  }

  /* ---------- widget ---------- */
  function BulkOrder(root) {
    this.root = root;
    root.__nbo = this;
    var dataNode = $('script[data-nbo-data]', root);
    try { this.data = JSON.parse(dataNode.textContent); } catch (e) { this.data = null; }
    if (!this.data || !Array.isArray(this.data.variants) || !this.data.variants.length) { root.hidden = true; return; }

    this.cfg = {
      productId: String(root.getAttribute('data-product-id') || this.data.productId),
      vatRate: parseFloat(root.getAttribute('data-vat-rate')) || 1,
      currencySuffix: root.getAttribute('data-currency-suffix') || 'lei',
      showStock: root.getAttribute('data-show-stock') !== 'false',
      position: root.getAttribute('data-position') || 'static',
      layout: root.getAttribute('data-layout') || 'color-tabs',
      title: root.getAttribute('data-title') || TEXT.title
    };
    this.variantsById = {};
    this.data.variants.forEach(function (v) { this.variantsById[String(v.id)] = v; }, this);
    this.cartQtyForProduct = 0;
    this.inputs = [];
    this.cellPrices = {};
    this.groupCounts = [];
    this.hasClickableColors = false;

    this.position();
    this.render();
    this.bind();
    this.refreshCartQty();
    this.update();
  }

  // Poziția blocului: 'static' (implicit) = exact unde e pus în editorul de temă;
  // 'after-calculator' = lipit sub blocul calculatorului; 'before-buy-buttons' = înaintea butoanelor de cumpărare.
  BulkOrder.prototype.position = function () {
    var mode = this.cfg.position;
    if (mode !== 'after-calculator' && mode !== 'before-buy-buttons') return;
    var section = this.root.closest('product-info, [id^="shopify-section"]');
    if (!section) return;
    var movable = this.root.closest('.product__block--custom_liquid') || this.root;
    var calcBlock = null;
    if (mode === 'after-calculator') {
      var calc = section.querySelector('[data-naturif-personalizare], #calculator-form-container');
      calcBlock = calc && calc.closest('.product__block');
      if (calcBlock && calcBlock !== movable && !movable.contains(calcBlock) && calcBlock.parentNode) {
        if (calcBlock.nextElementSibling !== movable) calcBlock.parentNode.insertBefore(movable, calcBlock.nextElementSibling);
        return;
      }
    }
    var buy = section.querySelector('.product__block--buy_buttons');
    if (!buy || buy === movable || movable.contains(buy) || movable.nextElementSibling === buy) return;
    buy.parentNode.insertBefore(movable, buy);
  };

  BulkOrder.prototype.section = function () {
    return this.root.closest('product-info, [id^="shopify-section"]') || document;
  };

  // Varianta reprezentativă pentru o culoare (cu imagine proprie): disponibilă dacă se poate.
  BulkOrder.prototype.mediaVariantFor = function (rowName) {
    var withMedia = this.data.variants.filter(function (v) { return v.option1 === rowName && v.featured_media && v.featured_media.id; });
    if (!withMedia.length) return null;
    return withMedia.filter(function (v) { return v.available; })[0] || withMedia[0];
  };

  /*
   * Arată în galerie imaginea culorii, FĂRĂ să schimbe varianta selectată în formular
   * (o schimbare de variantă ar reseta calculatorul de personalizare). Folosim direct
   * media-gallery.setActiveMedia() din temă, cu media asociată variantei.
   */
  BulkOrder.prototype.showColorMedia = function (rowName) {
    var variant = this.mediaVariantFor(rowName);
    if (!variant) return false;
    var section = this.section();
    var gallery = section.querySelector('media-gallery') || document.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return false;
    var fm = { id: variant.featured_media.id, position: variant.featured_media.position || 0, media_type: 'image' };
    var keepY = window.pageYOffset;
    try {
      if (typeof gallery.init === 'function') gallery.init();
      gallery.setActiveMedia({ featured_media: fm, featured_image: { id: fm.id, position: fm.position } });
    } catch (e) { return false; }
    // galeria poate reordona imaginile / muta focusul; pagina rămâne unde era
    if (Math.abs(window.pageYOffset - keepY) > 2) window.scrollTo(0, keepY);
    requestAnimationFrame(function () { if (Math.abs(window.pageYOffset - keepY) > 2) window.scrollTo(0, keepY); });
    // Nu derulăm la galerie: clientul e jos, la mărimi și cantități, și rămâne acolo.
    return true;
  };

  BulkOrder.prototype.setActiveColor = function (rowName) {
    $$('.nbo-group', this.root).forEach(function (g) { g.classList.toggle('is-active', g.getAttribute('data-row') === rowName); });
  };

  // Swatch-ul din selectorul temei (ascuns, dar prezent în DOM): label .swatch-color { --swatch-background: … }
  BulkOrder.prototype.themeSwatch = function (optionName, valueName) {
    var section = this.root.closest('product-info, [id^="shopify-section"]') || document;
    var inputs = $$('variant-selects input[type="radio"]', section).filter(function (i) { return i.value === valueName; });
    for (var k = 0; k < inputs.length; k++) {
      var input = inputs[k];
      var fieldset = input.closest('fieldset');
      var legend = fieldset && fieldset.querySelector('legend');
      if (legend && optionName && legend.textContent.indexOf(optionName) === -1) continue;
      var label = input.id ? section.querySelector('label[for="' + cssEscape(input.id) + '"]') : null;
      var sw = label && label.querySelector('.swatch-color, .swatch, [style*="--swatch-background"]');
      var style = (sw && sw.getAttribute('style')) || (label && label.getAttribute('style')) || '';
      var m = style.match(/--swatch-background\s*:\s*([^;]+)/);
      if (!m) continue;
      var val = m[1].trim();
      if (/^url\(/i.test(val)) return { image: val.replace(/^url\((['"]?)(.*?)\1\)$/i, '$2') };
      if (window.CSS && CSS.supports && CSS.supports('color', val)) return { color: val };
      var img = label.querySelector('img');
      if (img && img.currentSrc) return { image: img.currentSrc };
    }
    return null;
  };

  BulkOrder.prototype.findProductForm = function () {
    var scope = this.root.closest('product-info, [id^="shopify-section"], .shopify-section') || document;
    var pick = function (forms) {
      var pid = this.cfg.productId;
      return forms.filter(function (f) { return !f.classList.contains('installment'); })
        .sort(function (a, b) {
          var score = function (f) {
            var s = 0;
            var pidInput = f.querySelector('input[name="product-id"]');
            if (pidInput && String(pidInput.value) === pid) s += 2;
            if (f.getAttribute('is') === 'product-form') s += 1;
            return s;
          };
          return score(b) - score(a);
        })[0] || null;
    }.bind(this);
    return pick($$('form[action*="/cart/add"]', scope)) || pick($$('form[action*="/cart/add"]'));
  };

  BulkOrder.prototype.currentVariant = function () {
    var form = this.findProductForm();
    var idInput = form && form.querySelector('input[name="id"]');
    var id = idInput && idInput.value;
    return (id && this.variantsById[String(id)]) || null;
  };

  // Stilul swatch-ului pentru o valoare (tema → date Liquid → nume de culoare CSS); '' dacă nu există.
  BulkOrder.prototype.swatchStyle = function (value, optionName) {
    var theme = this.themeSwatch(optionName, value.name);
    if (theme && theme.image) return 'background-image:url(' + JSON.stringify(theme.image) + ')';
    if (theme && theme.color) return 'background-color:' + theme.color;
    if (value.image) return 'background-image:url(' + JSON.stringify(value.image) + ')';
    if (value.color) return 'background-color:' + value.color;
    var guess = String(value.name || '').toLowerCase().replace(/[^a-z]/g, '');
    if (guess && window.CSS && CSS.supports && CSS.supports('color', guess)) return 'background-color:' + guess;
    return '';
  };
  BulkOrder.prototype.swatchNode = function (style) {
    return el('span', { class: 'nbo-swatch' + (style ? '' : ' nbo-swatch--empty'), style: style || null, 'aria-hidden': 'true' });
  };

  /* ───────── ordinea mărimilor ─────────
   * Shopify nu ține o ordine proprie a valorilor unei opțiuni: ea rezultă din ordinea
   * în care apar variantele, iar la import variantele au intrat alfabetic. De aceea
   * mărimile vin „2XL, 3XL, 4XL, L, M, S, XL". Nu se poate corecta din Shopify —
   * un produs a cărui primă culoare n-are 2XL nu poate avea 2XL între XL și 3XL.
   * Le ordonăm aici, la afișare. Nu atingem variantele, doar ordinea coloanelor. */
  var SCARA_MARIMI = {
    '3XS': -4, 'XXXS': -4, '2XS': -3, 'XXS': -3, 'XS': -2, 'S': -1, 'M': 0, 'L': 1,
    'XL': 2, '2XL': 3, 'XXL': 3, '3XL': 4, 'XXXL': 4, '4XL': 5, 'XXXXL': 5, '5XL': 6,
    '6XL': 7, '7XL': 8, '8XL': 9, '9XL': 10, '10XL': 11
  };
  var MARIME_UNICA = { 'U': 1, 'UNI': 1, 'UNIC': 1, 'TU': 1, 'ONE SIZE': 1, 'UNIVERSAL': 1, 'NO SIZE': 1 };
  var INAINTE_DE_LUNI = { 'NB': -2, 'NOU NASCUT': -2, 'NOU-NĂSCUT': -2, 'PREMATURE': -3, 'PREEMIE': -3 };
  var LUNGIME_CRAC = { S: 0, R: 1, L: 2 }; // 28-S scurt, 28-R regular, 28-L lung

  function scaraLitera(t) { return SCARA_MARIMI[String(t).toUpperCase().replace(/\s+/g, '')]; }

  // Cheia de sortare: [grup, număr, număr secundar, text]. Grupurile țin valorile de
  // același fel împreună, ca un produs cu „U" și „S/M" să nu le amestece.
  function cheieMarime(nume) {
    var sus = String(nume == null ? '' : nume).trim().toUpperCase();
    if (MARIME_UNICA[sus]) return [0, 0, 0, sus];

    // tot șirul e din litere de mărime: „S", „S/M", „2XL/4XL", „XS-S"
    var parti = sus.split(/[\/\-]/);
    var litere = true;
    for (var i = 0; i < parti.length; i++) if (scaraLitera(parti[i].trim()) === undefined) { litere = false; break; }
    if (litere && parti.length) return [1, scaraLitera(parti[0].trim()), scaraLitera(parti[parti.length - 1].trim()), sus];

    // litera e în paranteză: „10 (S)", „2T (S)" — familia se ordonează după ea
    var paran = sus.match(/\(([^)]+)\)/);
    if (paran && scaraLitera(paran[1]) !== undefined) return [1, scaraLitera(paran[1]), 0, sus];

    if (INAINTE_DE_LUNI[sus] !== undefined) return [2, INAINTE_DE_LUNI[sus], 0, sus];

    // numerice: „42", „8/10", „110 cm/4 ani", „100X150", „28-L"
    var numere = sus.match(/\d+/g);
    if (numere) {
      // „2 ANI" vine după „18 LUNI" — vârstele se aduc toate în luni
      var ani = sus.match(/^(\d+)\s*(ANI?|Y|YRS?)\b/);
      var sufix = sus.match(/[-\s]([SRL])$/);
      return [2, ani ? Number(ani[1]) * 12 : Number(numere[0]),
              numere[1] ? Number(numere[1]) : (sufix ? LUNGIME_CRAC[sufix[1]] : 0), sus];
    }
    return [3, 0, 0, sus];
  }

  function comparaMarimi(a, b) {
    var ka = cheieMarime(a.name), kb = cheieMarime(b.name);
    for (var i = 0; i < 3; i++) if (ka[i] !== kb[i]) return ka[i] - kb[i];
    return String(ka[3]).localeCompare(String(kb[3]), 'ro');
  }

  // Doar opțiunea de mărime se sortează — culorile rămân în ordinea din Shopify,
  // acolo ordinea e o decizie a clientului. Câteva produse au sub „Mărime" cu totul
  // altceva (categorii Malfini: BASIC, CHILL, POLO SHIRTS); acolo nu există o ordine
  // firească, așa că le lăsăm cum sunt.
  function ordoneazaMarimile(options) {
    return options.map(function (o) {
      if (!/^(m[ăa]rime|size|talie)$/i.test(String(o.name || '').trim())) return o;
      var v = o.values || [];
      if (v.length < 2) return o;
      var recunoscute = v.filter(function (x) { return cheieMarime(x.name)[0] < 3; }).length;
      if (recunoscute < v.length / 2) return o;
      var copie = {};
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) copie[k] = o[k];
      copie.values = v.slice().sort(comparaMarimi);
      return copie;
    });
  }

  BulkOrder.prototype.render = function () {
    var self = this;
    var data = this.data;
    var options = ordoneazaMarimile((data.options || []).slice().sort(function (a, b) { return (a.position || 0) - (b.position || 0); }));
    var opt1 = options[0], opt2 = options[1], opt3 = options[2];
    // blocul de personalizare se poate încărca după matrice: subtitlul se actualizează în update()
    this.subtitleEl = el('p', { class: 'nbo-subtitle', text: TEXT.subtitleNoCalc });
    var head = el('div', { class: 'nbo-head' }, [
      el('h3', { class: 'nbo-title', text: this.cfg.title }),
      this.subtitleEl
    ]);
    this.root.appendChild(head);

    var meta = el('div', { class: 'nbo-meta' });
    this.unitPriceEl = el('p', { class: 'nbo-unit-price' });
    this.unitPriceEl.hidden = true;
    meta.appendChild(this.unitPriceEl);
    // o singură mărime (ex. „U”): o afișăm o dată, nu în fiecare celulă
    if (opt2 && opt2.values.length === 1 && opt2.values[0].name) {
      meta.appendChild(el('p', { class: 'nbo-size-note', text: opt2.name + ': ' + opt2.values[0].name }));
    }
    this.root.appendChild(meta);

    // un set de carduri per valoare option3 (rar); carduri = option1 (culoare), celule = option2 (mărime)
    // „color-tabs”: selector de culoare + cantități doar pentru culoarea aleasă (implicit);
    // „cards”: toate culorile desfășurate. La o singură mărime sau 3 opțiuni rămâne lista/cardurile.
    var single = !opt2 || opt2.values.length <= 1;
    this.tabs = this.cfg.layout === 'color-tabs' && !!opt1 && !single && !opt3;

    var groups = opt3 ? opt3.values.map(function (v) { return v.name; }) : [null];
    groups.forEach(function (g) {
      var variantsInGroup = data.variants.filter(function (v) { return g == null || v.option3 === g; });
      if (!variantsInGroup.length) return;
      if (g != null) self.root.appendChild(el('p', { class: 'nbo-group-title', text: opt3.name + ': ' + g }));
      var groupsEl = self.renderGroups(opt1, opt2, variantsInGroup);
      if (self.tabs) {
        groupsEl.classList.add('nbo-groups--tabs');
        self.root.appendChild(self.renderColorBar(opt1, groupsEl));
      }
      self.root.appendChild(groupsEl);
    });

    var current = this.currentVariant();
    if (this.tabs) {
      head.appendChild(el('p', { class: 'nbo-hint', text: TEXT.tabsHint }));
      var firstRow = $('.nbo-group', this.root);
      var startRow = (current && current.option1 && $('.nbo-group[data-row="' + cssEscape(current.option1) + '"]', this.root)) ? current.option1 : (firstRow ? firstRow.getAttribute('data-row') : null);
      if (startRow) this.selectColor(startRow, false);
    } else if (this.hasClickableColors) {
      head.appendChild(el('p', { class: 'nbo-hint', text: TEXT.colorHint }));
      if (current && current.option1) this.setActiveColor(current.option1);
    }

    this.totalQtyEl = el('strong', { text: '0 ' + TEXT.pieces });
    this.subtotalEl = el('strong', { text: '–' });
    this.tierEl = el('p', { class: 'nbo-tier' });
    this.linesEl = el('ul', { class: 'nbo-lines' });
    this.messageEl = el('div', { class: 'nbo-message', role: 'status', 'aria-live': 'polite' });
    this.messageEl.hidden = true;
    this.button = el('button', { type: 'button', class: 'btn btn--primary nbo-btn', html: '<span class="btn__text">' + escapeHtml(TEXT.addAll) + '</span>' });
    this.button.addEventListener('click', function () { self.addAll(); });

    var summary = el('div', { class: 'nbo-summary' }, [
      el('div', { class: 'nbo-totals' }, [
        el('div', {}, [el('span', { class: 'nbo-totals__label', text: TEXT.total + ': ' }), this.totalQtyEl]),
        el('div', {}, [el('span', { class: 'nbo-totals__label', text: TEXT.subtotal + ': ' }), this.subtotalEl])
      ]),
      el('p', { class: 'nbo-note', text: TEXT.subtotalNote }),
      this.tierEl,
      this.linesEl,
      this.button
    ]);
    this.root.appendChild(summary);
    this.root.appendChild(this.messageEl);
    this.root.classList.add('is-ready');
  };

  // Bara de culori (swatch-uri) pentru modul „color-tabs”; badge cu bucățile deja completate pe culoare.
  BulkOrder.prototype.renderColorBar = function (opt1, groupsEl) {
    var self = this;
    this.swatchButtons = this.swatchButtons || {};
    this.swatchBadges = this.swatchBadges || {};
    this.colorNameEl = el('strong', { class: 'nbo-color-label__value' });
    var bar = el('div', { class: 'nbo-colorbar' }, [
      el('p', { class: 'nbo-color-label' }, [(opt1.name || TEXT.colorLabel) + ': ', this.colorNameEl])
    ]);
    var list = el('div', { class: 'nbo-swatches', role: 'tablist' });
    $$('.nbo-group', groupsEl).forEach(function (g) {
      var row = g.getAttribute('data-row');
      var style = self.swatchStyle({ name: row }, opt1.name);
      var badge = el('span', { class: 'nbo-swatch-btn__badge', 'aria-hidden': 'true' });
      var btn = el('button', { type: 'button', class: 'nbo-swatch-btn', role: 'tab', title: row, 'aria-label': row, 'data-row': row }, [self.swatchNode(style), badge]);
      btn.addEventListener('click', function () { self.selectColor(row, true); });
      self.swatchButtons[row] = btn;
      self.swatchBadges[row] = badge;
      list.appendChild(btn);
    });
    bar.appendChild(list);
    return bar;
  };

  BulkOrder.prototype.selectColor = function (rowName, userAction) {
    this.activeColor = rowName;
    $$('.nbo-group', this.root).forEach(function (g) { g.classList.toggle('is-active', g.getAttribute('data-row') === rowName); });
    Object.keys(this.swatchButtons || {}).forEach(function (r) {
      var b = this.swatchButtons[r];
      b.classList.toggle('is-active', r === rowName);
      b.setAttribute('aria-selected', r === rowName ? 'true' : 'false');
    }, this);
    if (this.colorNameEl) this.colorNameEl.textContent = rowName;
    if (userAction) {
      this.showColorMedia(rowName); // imaginea culorii în galerie (fără schimbarea variantei)
      var firstInput = $('.nbo-group.is-active .nbo-input:not(:disabled)', this.root);
      if (firstInput && window.matchMedia && !window.matchMedia('(max-width: 1023px)').matches) firstInput.focus({ preventScroll: true });
    }
  };

  /*
   * Un card pe valoare a primei opțiuni (culoare); înăuntru, câte o celulă pe valoare a opțiunii a doua
   * (mărime), așezate în grilă auto-fill – se înfășoară pe mai multe rânduri când nu încap, fără scroll orizontal.
   * Combinațiile inexistente nu sunt afișate; cele epuizate apar dezactivate, cu „Epuizat”.
   */
  BulkOrder.prototype.renderGroups = function (opt1, opt2, variants) {
    var self = this;
    var rows = opt1 ? opt1.values : [{ name: '' }];
    var cols = opt2 ? opt2.values : [{ name: '' }];
    var single = cols.length === 1;
    var swatchStyles = opt1 ? rows.map(function (r) { return self.swatchStyle(r, opt1.name); }) : [];
    var showSwatches = swatchStyles.some(Boolean);
    var wrap = el('div', { class: 'nbo-groups' + (single ? ' nbo-groups--single' : '') });

    rows.forEach(function (r, ri) {
      var rowVariants = cols.map(function (c) {
        return variants.filter(function (v) {
          return (!opt1 || v.option1 === r.name) && (!opt2 || v.option2 === c.name);
        })[0] || null;
      });
      if (!rowVariants.some(Boolean)) return; // culoare fără nicio combinație

      var group = el('div', { class: 'nbo-group', 'data-row': r.name });
      var head = el('div', { class: 'nbo-group__head' });
      if (opt1) {
        if (showSwatches) head.appendChild(self.swatchNode(swatchStyles[ri]));
        head.appendChild(el('span', { class: 'nbo-group__name', text: r.name }));
        // culoarea e clicabilă dacă are imagine proprie în galerie
        if (self.mediaVariantFor(r.name)) {
          head.classList.add('nbo-group__head--clickable');
          head.setAttribute('role', 'button');
          head.setAttribute('tabindex', '0');
          head.setAttribute('title', fmt(TEXT.showColor, { color: r.name }));
          var activate = function (e) {
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            if (self.showColorMedia(r.name)) self.setActiveColor(r.name);
          };
          head.addEventListener('click', activate);
          head.addEventListener('keydown', activate);
          self.hasClickableColors = true;
        }
      }
      var count = el('span', { class: 'nbo-group__count' });
      head.appendChild(count);
      self.groupCounts.push({ el: count, rowName: r.name });
      group.appendChild(head);

      var cells = el('div', { class: 'nbo-cells' });
      cols.forEach(function (c, ci) {
        var variant = rowVariants[ci];
        if (!variant) return;
        var tracked = variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue';
        var max = tracked ? Math.max(0, parseInt(variant.inventory_quantity, 10) || 0) : null;
        var disabled = !variant.available || (tracked && max === 0);
        var cell = el('div', { class: 'nbo-cell' + (disabled ? ' nbo-cell--unavailable' : '') });
        if (opt2 && !single) cell.appendChild(el('span', { class: 'nbo-cell__label', text: c.name }));
        var input = el('input', {
          type: 'number', min: '0', step: '1', inputmode: 'numeric', autocomplete: 'off', placeholder: '0',
          class: 'nbo-input', 'data-variant-id': String(variant.id), 'data-row': r.name,
          'aria-label': variant.title, disabled: disabled, title: disabled ? TEXT.unavailable : variant.title
        });
        if (max != null && max > 0) input.setAttribute('max', String(max));
        cell.appendChild(input);
        if (!disabled) {
          var priceEl = el('span', { class: 'nbo-cell-price' });
          priceEl.hidden = true;
          cell.appendChild(priceEl);
          self.cellPrices[String(variant.id)] = priceEl;
        }
        if (disabled) {
          cell.appendChild(el('span', { class: 'nbo-cell-meta', text: TEXT.unavailable }));
        } else if (self.cfg.showStock && tracked) {
          cell.appendChild(el('span', { class: 'nbo-cell-meta', text: TEXT.stock + ' ' + max }));
        }
        if (!disabled) self.inputs.push(input);
        cells.appendChild(cell);
      });
      group.appendChild(cells);
      wrap.appendChild(group);
    });
    return wrap;
  };

  BulkOrder.prototype.bind = function () {
    var self = this;
    var debounced = debounce(function () { self.update(); }, 150);
    this.root.addEventListener('input', function (e) {
      if (!e.target.classList.contains('nbo-input')) return;
      self.clearError();
      self.clampInput(e.target);
      e.target.classList.toggle('has-qty', parseInt(e.target.value, 10) > 0);
      debounced();
    });
    // personalizarea sau varianta s-au schimbat → prețurile unitare se pot schimba
    var slow = debounce(function () { self.clearError(); self.update(); }, 150);
    document.addEventListener('naturif:personalizare:change', slow);
    document.addEventListener('naturif:personalizare:ready', slow);
    document.addEventListener('naturif:reduceri:ready', slow);
    document.addEventListener('variant:changed', slow);
    document.addEventListener('cart:updated', function () { self.refreshCartQty(); });
    document.addEventListener('cart-update', function () { self.refreshCartQty(); });
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (payload) {
        if (payload && payload.cart && Array.isArray(payload.cart.items)) self.setCartQty(payload.cart);
        else self.refreshCartQty();
      });
    }
  };

  BulkOrder.prototype.clampInput = function (input) {
    var v = input.value;
    if (v === '') return;
    var n = Math.floor(Number(v));
    if (!isFinite(n) || n < 0) n = 0;
    var max = parseInt(input.getAttribute('max'), 10);
    if (isFinite(max) && n > max) {
      n = max;
      var variant = this.variantsById[input.getAttribute('data-variant-id')];
      this.notify(fmt(TEXT.maxStock, { variant: variant ? variant.title : '', max: max, pieces: TEXT.pieces }), 'error');
    }
    if (String(n) !== v) input.value = n === 0 ? '' : String(n);
  };

  BulkOrder.prototype.collectLines = function () {
    var self = this;
    return this.inputs.map(function (input) {
      var qty = parseInt(input.value, 10);
      if (!isFinite(qty) || qty <= 0) return null;
      return { variant: self.variantsById[input.getAttribute('data-variant-id')], qty: qty, input: input };
    }).filter(Boolean);
  };

  /*
   * Prețul unitar (brut, în unități majore) pentru fiecare variantă = preț textil + personalizarea
   * pe bucată la pragul atins de grup (bucățile din matrice + cele deja în coș cu aceeași personalizare).
   */
  BulkOrder.prototype.computePricing = function (matrixTotal) {
    var unit = {};
    var result = { unit: unit, active: false, setup: 0, quote: null, groupId: null, total: matrixTotal || 0 };
    this.data.variants.forEach(function (v) { unit[String(v.id)] = v.price / 100; });
    var pz = personalizare(this.cfg.productId);
    if (!pz || !pz.isActive()) return result;

    var groupId = pz.groupId();
    var total = (matrixTotal || 0) + groupQtyInCart(this.cart, groupId);
    var q = pz.quote(total);
    Object.keys(unit).forEach(function (id) { unit[id] = Math.round((unit[id] + q.perPiece / 100) * 100) / 100; });
    // setup-ul se plătește o singură dată: nu îl mai numărăm dacă grupul îl are deja în coș
    var inCart = (this.cart && this.cart.items || []).filter(function (i) { return i.properties && i.properties._nf_group === groupId && i.properties._nf_role === 'u'; });
    q.setups.forEach(function (s) {
      var already = inCart.some(function (i) { return i.properties._nf_pos === s.choice.position; });
      if (!already) result.setup += s.variant.price;
    });
    result.active = true;
    result.quote = q;
    result.groupId = groupId;
    result.total = total;
    return result;
  };

  BulkOrder.prototype.update = function () {
    var self = this;
    var lines = this.collectLines();
    var matrixTotal = lines.reduce(function (s, l) { return s + l.qty; }, 0);
    var pricing = this.computePricing(matrixTotal);
    var total = 0, subtotalMinor = 0;

    var pz = personalizare(this.cfg.productId);
    if (this.subtitleEl) this.subtitleEl.textContent = pz ? TEXT.subtitle : TEXT.subtitleNoCalc;
    if (pz) pz.setTotal(pricing.active ? pricing.total : matrixTotal);

    // preț unitar: o singură linie când toate combinațiile au același preț, altfel sub fiecare câmp
    var prices = this.inputs.map(function (input) { return pricing.unit[input.getAttribute('data-variant-id')]; });
    var uniform = prices.length > 0 && prices.every(function (p) { return Math.abs(p - prices[0]) < 0.005; });
    this.unitPriceEl.hidden = !uniform;
    if (uniform) this.unitPriceEl.innerHTML = TEXT.unitPrice + ': <strong>' + escapeHtml(formatMoney(prices[0] * 100, this.cfg)) + '</strong>';
    Object.keys(this.cellPrices).forEach(function (id) {
      var node = self.cellPrices[id];
      node.hidden = uniform;
      if (!uniform) node.textContent = formatMoney(pricing.unit[id] * 100, self.cfg).replace(' ' + TEXT.vat, '');
    });

    this.linesEl.innerHTML = '';
    lines.forEach(function (l) {
      var unitGross = pricing.unit[String(l.variant.id)];
      total += l.qty;
      subtotalMinor += unitGross * 100 * l.qty;
      self.linesEl.appendChild(el('li', {}, [
        el('span', { text: l.variant.title + ' × ' + l.qty + ' (' + formatMoney(unitGross * 100, self.cfg) + TEXT.perPiece + ')' }),
        el('span', { text: formatMoney(unitGross * 100 * l.qty, self.cfg) })
      ]));
    });
    if (total && pricing.active && pricing.setup) {
      subtotalMinor += pricing.setup;
      self.linesEl.appendChild(el('li', { class: 'nbo-lines__setup' }, [
        el('span', { text: TEXT.setup }),
        el('span', { text: formatMoney(pricing.setup, self.cfg) })
      ]));
    }
    var perRow = {};
    lines.forEach(function (l) { var r = l.input.getAttribute('data-row'); perRow[r] = (perRow[r] || 0) + l.qty; });
    this.groupCounts.forEach(function (g) { g.el.textContent = perRow[g.rowName] ? perRow[g.rowName] + ' ' + TEXT.pieces : ''; });
    Object.keys(this.swatchBadges || {}).forEach(function (r) { self.swatchBadges[r].textContent = perRow[r] ? String(perRow[r]) : ''; });
    this.totalQtyEl.textContent = total + ' ' + TEXT.pieces;
    this.subtotalEl.textContent = total ? formatMoney(subtotalMinor, this.cfg) : '–';
    this.button.disabled = total === 0;
    this.updateTier(total);
  };

  BulkOrder.prototype.updateTier = function (matrixTotal) {
    var tiers = discountTiers(this.cfg.productId);
    var total = matrixTotal + (this.cartQtyForProduct || 0);
    document.dispatchEvent(new CustomEvent('naturif:bulk:update', { detail: { productId: this.cfg.productId, total: total, matrixTotal: matrixTotal } }));
    this.tierEl.textContent = '';
    if (!tiers.length || !matrixTotal) return;
    var reached = null, next = null;
    tiers.forEach(function (t) { if (total >= t.min) reached = t; else if (!next) next = t; });
    var parts = [];
    if (reached) parts.push(fmt(TEXT.tierReached, { total: total, pieces: TEXT.pieces, pct: reached.pct }));
    if (next) parts.push(fmt(TEXT.tierNext, { left: next.min - total, pieces: TEXT.pieces, pct: next.pct }));
    this.tierEl.textContent = parts.join(' ');
  };

  BulkOrder.prototype.setCartQty = function (cart) {
    var pid = this.cfg.productId, qty = 0;
    (cart.items || []).forEach(function (item) { if (String(item.product_id) === pid) qty += item.quantity || 0; });
    this.cartQtyForProduct = qty;
    this.cart = cart;
    this.update();
  };

  BulkOrder.prototype.refreshCartQty = function () {
    var self = this;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { self.setCartQty(cart); })
      .catch(function () {});
  };

  BulkOrder.prototype.clearError = function () {
    if (this.messageEl && this.messageEl.classList.contains('nbo-message--error')) this.notify('');
  };

  BulkOrder.prototype.notify = function (message, type) {
    var box = this.messageEl;
    box.textContent = message || '';
    box.className = 'nbo-message' + (type ? ' nbo-message--' + type : '');
    box.hidden = !message;
    clearTimeout(this._notifyTimer);
    if (type === 'success') this._notifyTimer = setTimeout(function () { box.hidden = true; }, 6000);
  };

  BulkOrder.prototype.setLoading = function (on) {
    this.button.classList.toggle('btn--loading', on);
    this.button.setAttribute('aria-disabled', on ? 'true' : 'false');
    this.button.disabled = on;
    var label = this.button.querySelector('.btn__text');
    if (label) label.textContent = on ? TEXT.adding : TEXT.addAll;
  };

  BulkOrder.prototype.addAll = function () {
    var self = this;
    if (this._busy) return;
    this.notify('');
    var lines = this.collectLines();
    if (!lines.length) return this.notify(TEXT.noQty, 'error');

    this._busy = true;
    this.setLoading(true);
    this.submitLines(lines).catch(function (err) {
      self.handleError(err);
    }).then(function () { self._busy = false; self.setLoading(false); });
  };

  BulkOrder.prototype.handleError = function (err) {
    if (window.console) console.warn('[naturif-bulk-order] adăugare în coș:', err);
    var msg = err && err.message ? err.message : '';
    if (!(err && (err.handled || err.status === 422))) msg = TEXT.genericError;
    this.notify(msg, 'error');
    var pz = personalizare(this.cfg.productId);
    if (err && err.personalization && pz) pz.focus(msg);
  };

  /*
   * Liniile trimise în coș: textilul (cu descrierea personalizării) + câte o linie de serviciu pe
   * poziție (la prețul pragului pentru tot grupul) + setup-ul, dacă grupul nu îl are deja.
   */
  BulkOrder.prototype.submitLines = function (lines) {
    var self = this;
    var core = window.NaturifCore;
    var pz = personalizare(this.cfg.productId);
    var matrixTotal = lines.reduce(function (s, l) { return s + l.qty; }, 0);
    var baseProps = readFormProperties(this.findProductForm());
    var getCart = core ? core.cart.get() : Promise.resolve(this.cart || { items: [] });

    return getCart.then(function (cart) {
      self.cart = cart;
      var active = !!(pz && pz.service());
      var groupId = active ? pz.groupId() : null;
      var total = matrixTotal + (groupId ? groupQtyInCart(cart, groupId) : 0);
      if (active) {
        var errors = pz.validate(total);
        if (errors.length) {
          var invalid = new Error(errors[0]);
          invalid.handled = true;
          invalid.personalization = true;
          throw invalid;
        }
      }
      var textileProps = Object.assign({}, baseProps, active ? pz.textileProperties(groupId) : {});
      var items = lines.map(function (l) {
        var item = { id: l.variant.id, quantity: l.qty };
        if (Object.keys(textileProps).length) item.properties = Object.assign({}, textileProps);
        return item;
      });
      if (active) items = items.concat(pz.serviceItems(groupId, matrixTotal, total, cart));
      var merge = !!(groupId && groupQtyInCart(cart, groupId) > 0);
      return self.postItems(items, lines, active ? pz.file : null, merge);
    });
  };

  BulkOrder.prototype.postItems = function (items, lines, file, merge) {
    var self = this;
    var core = window.NaturifCore;
    // secțiunile pe care tema vrea să le redeseneze (coș lateral etc.); goale când coșul e „pagină”
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));

    var routes = (window.FoxTheme && FoxTheme.routes) || {};
    var cartUrl = (routes.cart_url || '/cart').replace(/\.js$/, '') + '.js';
    var totalQty = lines.reduce(function (s, l) { return s + l.qty; }, 0);

    var fileProperty = window.NaturifPersonalizare ? window.NaturifPersonalizare.FILE_PROPERTY : 'Fișier grafică';
    var added = core
      ? core.addItems(items, file, fileProperty)
      : fetch((routes.cart_add_url || '/cart/add').replace(/\.js$/, '') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); }).then(function (parsed) {
          if (parsed.status) { var err = new Error(parsed.description || parsed.message || TEXT.genericError); err.handled = true; throw err; }
          return parsed;
        });

    return added
      // doar dacă aceeași personalizare era deja în coș: unim liniile de personalizare
      .then(function (parsed) {
        if (!merge || !window.NaturifCartSync) return parsed;
        return window.NaturifCartSync.reconcile().catch(function () {}).then(function () { return parsed; });
      })
      .then(function (parsed) {
        // Produsele sunt deja în coș: de aici încolo nimic nu mai are voie să arate „eroare la adăugare”.
        self.onAdded(totalQty, lines);
        return Promise.all([
          fetch(cartUrl, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
          core && sections.length ? core.fetchSections(sections, window.location.pathname) : Promise.resolve(null)
        ]).then(function (res) {
          var cart = res[0];
          if (res[1]) cart.sections = res[1];
          var safe = function (fn) {
            try { fn(); } catch (e) { if (window.console) console.warn('[naturif-bulk-order] după adăugare:', e); }
          };
          safe(function () { self.setCartQty(cart); });
          safe(function () { if (window.FoxTheme && FoxTheme.pubsub) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart }); });
          safe(function () { document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsed } })); });
          safe(function () { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, source: 'naturif-bulk-order' } })); });
          // doar dacă tema folosește coș lateral („drawer”); cu coș „pagină” clientul rămâne pe produs
          var cartType = window.FoxTheme && FoxTheme.settings && FoxTheme.settings.cartType;
          var drawer = document.querySelector('cart-drawer');
          if (cartType !== 'page' && drawer && typeof drawer.show === 'function') safe(function () { drawer.show(self.button); });
        }, function (e) {
          if (window.console) console.warn('[naturif-bulk-order] reîmprospătare coș:', e);
        });
      });
  };

  // Confirmarea: mesaj sub buton + notificare sus, fără redirect.
  BulkOrder.prototype.onAdded = function (totalQty, lines) {
    lines.forEach(function (l) { l.input.value = ''; l.input.classList.remove('has-qty'); });
    this.update();
    this.notify(fmt(TEXT.success, { qty: totalQty, pieces: TEXT.pieces }), 'success');
    var routes = (window.FoxTheme && FoxTheme.routes) || {};
    var old = document.getElementById('nbo-added-toast');
    if (old) old.remove();
    var toast = el('div', { id: 'nbo-added-toast', class: 'nbo-toast', role: 'status' }, [
      el('span', { text: '✓ ' + fmt(TEXT.success, { qty: totalQty, pieces: TEXT.pieces }) }),
      el('a', { href: routes.cart_url || '/cart', text: 'Vezi coșul →' })
    ]);
    document.body.appendChild(toast);
    setTimeout(function () { toast.classList.add('is-visible'); }, 10);
    setTimeout(function () { toast.classList.remove('is-visible'); setTimeout(function () { toast.remove(); }, 400); }, 5000);
  };

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); var args = arguments, ctx = this; t = setTimeout(function () { fn.apply(ctx, args); }, ms); };
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function init(scope) {
    $$(ROOT_SELECTOR, scope || document).forEach(function (root) { if (!root.__nbo) new BulkOrder(root); });
  }

  window.NaturifBulkOrder = { init: init, BulkOrder: BulkOrder };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
